import axios from 'axios'

const axiosInstance = axios.create()

axiosInstance.defaults.withCredentials = true
axiosInstance.defaults.timeout = 90000

axiosInstance.interceptors.request.use(
  (config) => {
    config.headers = {
      Accepted: 'application/json',
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
      ...config.headers
    }
    return config
  },
  (error) => Promise.reject(error)
)

export default axiosInstance
